import { Component, Host, h, Prop, State } from '@stencil/core';
const fa_script = document.createElement('script');

fa_script.src = 'https://kit.fontawesome.com/5ad2be44b5.js';
fa_script.setAttribute('crossorigin', 'anonymous');
document.body.appendChild(fa_script);

const currentYear = new Date().getFullYear();

@Component({
  tag: 'portal-footer',
  styleUrl: 'portal-footer.scss',
  shadow: true,
})
export class PortalFooter {
  /**
   * The dev env
   */
  @Prop() env?: string = 'prod';
  @Prop() isMobile: boolean = false;
  @State() showCookies: boolean = false;
  @Prop() bussiness_url = 'https://www.brighttalk.com/business';

  // If env isn't prod then use the other gdpr id. otherwise always use prod id.
  private getGdprId(): string {
    let gdprId;
    if (this.env !== 'prod') {
      gdprId = 894599;
    } else {
      gdprId = 943892;
    }

    return gdprId;
  }

  // private getCdnUrl(): string {
  //     let url = '';
  //     switch(this.env) {
  //         case 'int05':
  //         url = 'https://assets.int05.brighttalk.net';
  //         break;
  //         case 'test01':
  //         url = 'https://assets.test01.brighttalk.net';
  //         break;
  //         case 'stage':
  //             url = 'https://assets.stage.brighttalk.net';
  //             break;
  //         default:
  //         url = 'https://assets.brighttalk.com';
  //     }
  //     return url;
  // }
  async componentWillLoad() {
    this.showCookies = false;
    if (window['__tcfapi']) {
      var self = this;
      await window['__tcfapi']('getTCData', 2, function (data) {
        console.log('on react data.gdprApplies: ' + data.gdprApplies);
        if (data.gdprApplies) {
          console.log('gdprApplies');
          self.showCookies = true;
        } else {
          console.log('gdpr not Applies');
        }
      });
    }
  }
  render() {
    return (
      <Host>
        <div class="btalk-wrap-footer btalk-sitemain-footer">
          <footer class="top btalk-top-footer">
            <div class="btalk-footer-content">
              <div class="btalk-container max width btalk-widgets-grid">
                <div class="widget-wrap ">
                  <div class="widget widget_nav_menu">
                    <h3 class="h-widget">Marketing solutions</h3>
                    <ul class="menu">
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308415">
                        <a target="_blank" rel="noopener" href={this.bussiness_url + '/why-brighttalk'}>
                          Overview
                        </a>
                      </li>
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308416">
                        <a target="_blank" rel="noopener" href={this.bussiness_url + '/products/channels'}>
                          Webinars
                        </a>
                      </li>
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308417">
                        <a target="_blank" rel="noopener" href={this.bussiness_url + '/products/lead-generation'}>
                          Lead generation
                        </a>
                      </li>
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308418">
                        <a target="_blank" rel="noopener" href={this.bussiness_url + '/products/virtual-events'}>
                          Virtual events
                        </a>
                      </li>
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308419 last">
                        <a target="_blank" rel="noopener" href={this.bussiness_url + '/request-a-demo'}>
                          Request a demo
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="widget-wrap ">
                  <div class="widget widget_nav_menu">
                    <h3 class="h-widget">Company</h3>
                    <ul class="menu">
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308420">
                        <a target="_blank" rel="noopener" href={this.bussiness_url + '/company/about'}>
                          About
                        </a>
                      </li>
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308421">
                        <a target="_blank" rel="noopener" href={this.bussiness_url + '/academy/blog'}>
                          Blog
                        </a>
                      </li>
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308422">
                        <a target="_blank" rel="noopener" href="https://www.techtarget.com/about-us/careers/">
                          Careers
                        </a>
                      </li>
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308423 last">
                        <a target="_blank" rel="noopener" href={this.bussiness_url + '/company/contact'}>
                          Contact
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="widget-wrap ">
                  <div class="widget widget_nav_menu">
                    <h3 class="h-widget">Support</h3>
                    <ul class="menu">
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308425">
                        <a
                          target="_blank"
                          rel="noopener"
                          href="https://techtarget.service-now.com/csm?id=kb_category&kb_id=59c5c978fbb09a10874bfb624eefdca0&kb_category=f708c1f8fbb09a10874bfb624eefdc8c"
                        >
                          Channel owners
                        </a>
                      </li>
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308427">
                        <a
                          target="_blank"
                          rel="noopener"
                          href="https://techtarget.service-now.com/csm?id=kb_category&kb_id=59c5c978fbb09a10874bfb624eefdca0&kb_category=3e984df8fbb09a10874bfb624eefdc10"
                        >
                          Presenters
                        </a>
                      </li>
                      <li class=" menu-item menu-item-type-custom menu-item-object-custom menu-item-308429 last">
                        <a
                          target="_blank"
                          rel="noopener"
                          href="https://techtarget.service-now.com/csm?id=kb_category&kb_id=59c5c978fbb09a10874bfb624eefdca0&kb_category=9d990d3cfbb09a10874bfb624eefdced"
                        >
                          Viewers
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </footer>
          <footer class="btalk-colophon bottom btalk-bottom-footer web-comp-2">
            <div class="btalk-container max width">
              <div class="wrap">
                <div class="btalk-colophon-content">
                  <div class="site-footer-colophon">
                    <p class="site-copyright">
                      {' '}
                      Ⓒ {currentYear} BrightTALK, a subsidiary of
                      <a class="text-link" target="_blank" rel="nofollow" href="https://www.techtarget.com/">
                        {' '}
                        TechTarget, Inc.
                      </a>
                    </p>
                    <nav class="bt-footer-nav bt-company-links">
                      <ul class="foot-nav-items" id="footer-2-ul">
                        <li>
                          <a href={this.bussiness_url + '/terms-and-conditions'} rel="nofollow" target="_blank">
                            Legal
                          </a>
                        </li>
                        <li>
                          <a href={'https://www.techtarget.com/privacy-policy/'} rel="nofollow" target="_blank">
                            Privacy policy
                          </a>
                        </li>
                        <li>
                          <a href="https://techtarget.zendesk.com/hc/en-us/requests/new?ticket_form_id=360004852434" rel="nofollow" target="_blank">
                            Do Not Sell or Share My Personal Information
                          </a>
                        </li>
                        <li>
                          <a
                            id="gdpr_link "
                            style={{ display: this.showCookies == true ? '' : 'none' }}
                            onClick={() => {
                              window['_sp_'].gdpr.loadPrivacyManagerModal(this.getGdprId());
                            }}
                            href="javascript:void(0);"
                          >
                            Cookie Preferences
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <div class="btalk-social-icons">
                  <div class="btalk-social-global">
                    <a href="https://www.linkedin.com/company/brighttalk" class="linkedin" title="LinkedIn" target="_blank" rel="”nofollow”">
                      <svg fill="#f5f5f5" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                        <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
                      </svg>
                    </a>
                    <a href="https://twitter.com/brighttalk" class="twitter" title="Twitter" target="_blank" rel="”nofollow”">
                      <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                        <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z" />
                      </svg>
                    </a>
                    <a href="https://www.facebook.com/BrightTALK" class="facebook" title="Facebook" target="_blank" rel="”nofollow”">
                      <svg fill="#f5f5f5" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                        <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z" />
                      </svg>
                    </a>
                  </div>
                </div>
                <div id="cmp-banner"></div>
              </div>
            </div>
          </footer>
        </div>
      </Host>
    );
  }
}
